import OpenAiLogoIcon from "@/assets/icons/brands/openai.svg?react";
import { cn } from "@/lib/utils";

/** OpenAI's mark, in the current text colour (ChatGPT's own mark is monochrome). */
export default function OpenAiLogo({ className }: { className?: string }) {
  return <OpenAiLogoIcon className={cn("shrink-0 text-co-text [&_path]:fill-current", className)} aria-hidden />;
}
